<template>
  <div class="modal" :class="{ visible, full }" @click="_close($event)">
    <div class="modal-body" :class="[bodyClass ? bodyClass : '']">
      <slot />
    </div>
    <ModalCloseModal v-if="closeBtn" @click="close" />
  </div>
</template>

<script setup>
const visible = ref(false);
const props = defineProps(["closeBtn", "full", "bodyClass"]);
const emit = defineEmits(["closed"]);
setTimeout(() => {
  document.body.classList.add("frzn");
  visible.value = true;
}, 20);

const _close = (e) => {
  if (e.target.classList.contains("modal-body") && !props.full) close();
};

const close = () => {
  visible.value = false;
  setTimeout(() => {
    if (document.querySelectorAll(".modal").length == 1)
      document.body.classList.remove("frzn");
    emit("closed");
  }, 300);
};

defineExpose({ close });

const esc = (e) => {
  if (e.keyCode == 27) close();
};
onMounted(() => document.addEventListener("keydown", esc));
onUnmounted(() => document.removeEventListener("keydown", esc));
</script>
